import React, { useMemo } from 'react';
import { TitleLink } from './headerStyles';
import { DynamicLink } from 'utils/links';
import { DomData } from 'utils/dom';

export const HeaderLogo = ({ siteTitle, path }) => {
    const { isBrowser, screenWidth, domLoaded } = DomData();
    const Logo = useMemo(() => {
        if (isBrowser && domLoaded) {
            if (screenWidth !== 'small' && path === '/') return React.lazy(() => import('static/icons/logo-ease-reversed.svg'));
            else return React.lazy(() => import('static/icons/logo-ease.svg'));
        } else return null;
    }, [isBrowser, screenWidth, domLoaded, path]);

    return useMemo(
        () => (
            <DynamicLink
                link={{ url: `/` }}
                component={TitleLink}
                title={siteTitle}
            >
                {Logo && (
                    <React.Suspense fallback={<svg></svg>}>
                        <Logo />
                    </React.Suspense>
                )}
            </DynamicLink>
        ),
        [Logo, siteTitle]
    );
};

export default HeaderLogo;
